export const menuTipsHeaders = {
  STARTTURN: 'СТАРТ ХОДА',
  STUN: 'ОГЛУШЕНИЕ',
  INVISIBILITY: 'НЕВИДИМОСТЬ',
  REACTION: 'РЕАКЦИЯ',
  EVASION: 'УКЛОНЕНИЕ',
  MASSIVEBLOW: 'МАССОВЫЙ УДАР Х',
  SHOCKWAVE: 'УДАРНАЯ ВОЛНА Х',
  MAGICSHIELD: 'МАГИЧЕСКИЙ ЩИТ',
  POISONATTACK: 'ЯДОВИТАЯ АТАКА Х',
  LASTCAST: 'ПОСЛЕДНИЙ ВЫЗОВ',
  PROTECTOR: 'ЗАЩИТНИК',
  IMMOBILIZED: 'НЕ ДВИГАЕТСЯ',
  FIGHTER: 'БОЕЦ',
  FLYER: 'ЛЕТАЮЩИЙ',
  SHOOTER: 'СТРЕЛОК',
  SWIFT: 'СТРЕМИТЕЛЬНОСТЬ',
  PIERCING: 'ПРОНИКАЮЩАЯ АТАКА Х',
  SKILL: 'НАВЫК',
  HEROABILITY: 'СПОСОБНОСТЬ ГЕРОЯ',
  ARTEFACT: 'АРТЕФАКТ',
  MASSATTACK: 'ДАЛЬНЯЯ АТАКА',
  RETRIBUTION: 'ВОЗМЕЗДИЕ',
  INSTANT: 'МГНОВЕННОЕ',
  TEMPORARY: 'ВРЕМЕННОЕ',
  PERMANENT: 'ПОСТОЯННОЕ',
  swift: 'СТРЕМИТЕЛЬНОСТЬ',
  resistance: 'МАГИЧЕСКИЙ ЩИТ',
  protection: 'ЗАЩИТА',
  massAttack: 'ДАЛЬНЯЯ АТАКА',
  fly: 'ПОЛЕТ',
  shooter: 'СТРЕЛЬБА',
};

export const menuTipsText = {
  STARTTURN: 'Этот эффект применяется во время старта хода владельца карты',
  LASTCAST: 'Эффект применяется перед тем как карта с этим эффектом отправится в сток',
  STUN: 'Поворачивает воина в состояние оглушения',
  INVISIBILITY: 'Воин с невидимостью игнорирует ответные удары и не позволяет воинам атаковать его, но враги могут атаковать героя или других воинов сквозь этого воина',
  REACTION: 'Эта способность применяется в ответ на какое-то действие противника. Применение карты со способностью не отнимает очки действия - они отнимаются только если способность сработала',
  EVASION: 'Воин поглощает первый урон от атаки вражеского воина по нему во время хода оппонента, но получает оглушение и передвигается на соседнюю клетку на линии не нанося ответный удар (не сработает, если оглушен или не может передвинуться)',
  MASSIVEBLOW: 'При атаке в свой ход по воину, дополнительно отнимает Х здоровья у воинов в соседних клетках на линии рядом с целью',
  SHOCKWAVE: 'Вместо хода воина атаковать заклинанием пустую клетку в шеренге где он находится, при этом отнимает Х здоровья у вражеских воинов в соседних клетках',
  MAGICSHIELD: 'Снижает урон от атакующих заклинаний по воину с щитом на 50% (снизит 3 урона из 5-ти)',
  POISONATTACK: 'При базовой атаке в свой ход по воину, накладывает Х заклинаний Яд на атакуемого воина (можно взять его из стока или кладбища, если нет в руке)',
  PROTECTOR: 'Если защитник стоит в передней линии, то вражеские воины не могут атаковать воина, стоящего позади защитника',
  IMMOBILIZED: 'Этот воина не может передвигаться в свой ход',
  FIGHTER: 'Атакует только ближайших к нему воинов в шеренге',
  FLYER: 'Атакует любого воина в шеренге',
  SHOOTER: 'Атакует любого воина в шеренге, игнорирует ответную атаку',
  SWIFT: 'Воин со стремительностью может передвинуться, а потом атаковать в одном ходу',
  PIERCING: 'При атаке в свой ход по воину, атакует заклинанием силой Х другого вражеского воина в шеренге',
  SKILL: 'После использования, карта наывыка возращается обратно к вам в руку, а не на кладбище',
  HEROABILITY: 'Для использования карты ваш герой должен быть активен. Использование карты поварачивает вашего героя',
  ARTEFACT: 'Накладывается на героя и находится на нем пока не закончатся заряды артефакта. За применение эффекта артефакта отнимается 1 заряд',
  MASSATTACK: 'Воин может атаковать любого вражеского воина на поле',
  RETRIBUTION: 'Воин совершает ответный удар, даже если умирает от атаки по нему',
  INSTANT: 'После применения, заклинание отправляется в сток',
  TEMPORARY: 'Заклинание действует до начала вашего слелующего хода',
  PERMANENT: 'Заклинание действует пока карта, на которую оно наложено, находится на поле',
  swift: 'Воин со стремительностью может передвинуться, а потом атаковать в одном ходу',
  resistance: 'Снижает урон от атакующих заклинаний по воину с щитом на 50% (снизит 3 урона из 5-ти)',
  protection: 'Снижен урон от воинов',
  massAttack: 'Воин может атаковать любого вражеского воина на поле',
  fly: 'Воин с полетом может атаковать любого воина в шеренге',
  shooter: 'Воин со стрельбой атакует лобого воина в шеренге и игнорирует ответный удар',
};
